import React from "react";
import { useTranslation } from "react-i18next"; // Import useTranslation
import { useGetAvailableLanguages } from "../../hooks/global/Languages";

function LanguagesSelector({ lang }) { // Destructure lang from props
	const { i18n } = useTranslation(); // Get i18n instance
	const availableLan = useGetAvailableLanguages();

	const handleChangeLanguage = (lng) => {
		i18n.changeLanguage(lng); // Change the language using i18n
	};

	return (
		<div className="col-md-8 col-md-offset-2 col-sm-10 col-sm-offset-1 col-xs-12">
			<div className="languageSelectorWrap">
				{availableLan.map(lng => {
					return (
						<div className="languageSelector" key={lng}>
							{/* Use radio buttons for language selection */}
							<input
								id={"reviewId" + lng}
								checked={lng === i18n.language} // Check the current language
								onChange={() => handleChangeLanguage(lng)} // Call handleChangeLanguage on change
								name="reviewLanguageRadio" // Ensure name is the same to group radios
								type="radio" // Changed to radio for single selection
							/>
							<label htmlFor={"reviewId" + lng}>{lng}</label>
						</div>
					)
				})}
			</div>
		</div>
	);
}

export default LanguagesSelector;
